<section class="orchestration-shell">
  <header class="shell-header">
    <div>
      <h1>{{ 'Orchestration' | translate }}</h1>
      <p>{{ 'Assignments, subscriptions, workers, and resource limits' | translate }}</p>
    </div>
    <a class="admin-link" routerLink="/admin"><i class="pi pi-arrow-left"></i>{{ 'Administration' | translate }}</a>
  </header>

  <nav class="orchestration-nav" [attr.aria-label]="'Orchestration navigation' | translate">
    @for (link of links; track link.url) {
      <a
        [routerLink]="link.url"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: link.url === '/admin/orchestration' }">
        <i [class]="link.icon"></i>
        <span>{{ link.label | translate }}</span>
      </a>
    }
  </nav>

  <main class="shell-content"><router-outlet></router-outlet></main>
</section>
